import React, { useEffect, useState } from "react";
import "./Pricing.css";

const Pricing = () => {
  const [plans, setPlans] = useState([]);
  const [activePlan, setActivePlan] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const token = localStorage.getItem("jwtToken");
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/payment_links`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const result = await response.json();
        if (!result.error) {
          const active = result.data.find((p) => p.isActive);
          setActivePlan(active || null);
          setPlans(result.data);
        } else {
          setError(result.msg);
        }
      } catch (err) {
        setError("Failed to fetch plans.");
      }
    };

    fetchPlans();
  }, []);

  const handleCancelSubscription = async () => {
    try {
      const token = localStorage.getItem("jwtToken");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/cancel_subscription`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();
      if (result.error) {
        alert("Error: " + result.msg);
      } else {
        alert("Subscription cancelled successfully.");
        window.location.reload();
      }
    } catch (err) {
      alert("Failed to cancel subscription.");
    }
  };

  return (
    <div className="pricing-container">
      <div className="pricing-title">Subscription Plans</div>

      {activePlan && (
        <div className="active-plan-banner">
          <p>
            Your active plan: <strong>{activePlan.name}</strong> | Expires:{" "}
            <strong>
              {new Date(activePlan.expiry).toISOString().split("T")[0]}
            </strong>{" "}
            | Days left:{" "}
            <strong>
              {Math.max(
                0,
                Math.ceil(
                  (new Date(activePlan.expiry) - new Date()) /
                    (1000 * 60 * 60 * 24)
                )
              )}
            </strong>
          </p>
        </div>
      )}

      <div className="pricing-comparison">
        <div className="comparison-title">Upgrade to Premium and Enjoy:</div>
        <table className="comparison-table">
          <thead>
            <tr>
              <th>Feature</th>
              <th>Free</th>
              <th>Premium</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Full access to all DVSA ADI practice questions</td>
              <td>2 Categories</td>
              <td>All</td>
            </tr>
            <tr>
              <td>Access to unlimited mock tests</td>
              <td>❌</td>
              <td>✅</td>
            </tr>
            <tr>
              <td>Access to hazard perception videos</td>
              <td>❌</td>
              <td>✅</td>
            </tr>
            <tr>
              <td>Access to all case study questions</td>
              <td>❌</td>
              <td>✅</td>
            </tr>
          </tbody>
        </table>
      </div>

      {error && <p className="pricing-error">{error}</p>}

      <div className="pricing-cards">
        {plans.map((plan, index) => (
          <div
            key={index}
            className={`pricing-card ${plan.isActive ? "active" : ""}`}
          >
            <div className="plan-header">
              <div>{plan.name}</div>
              {plan.isActive && <span className="active-label">ACTIVE</span>}
              {!plan.isActive && plan.recommended && (
                <span className="recommended-label">RECOMMENDED</span>
              )}
            </div>
            <div className="plan-duration">{plan.validity}</div>
            <div className="plan-price">{plan.price}</div>
            {plan.expiry && plan.isActive && (
              <div className="plan-expiry">
                Expires: {new Date(plan.expiry).toISOString().split("T")[0]}
              </div>
            )}
            {plan.expiry && plan.isActive && (
              <div className="plan-days-left">
                Days left:{" "}
                {Math.max(
                  0,
                  Math.ceil(
                    (new Date(plan.expiry) - new Date()) / (1000 * 60 * 60 * 24)
                  )
                )}
              </div>
            )}
            {plan.isActive ? (
              <button
                className="cancel-button"
                onClick={handleCancelSubscription}
              >
                Cancel Subscription
              </button>
            ) : (
              <button
                className="choose-button"
                onClick={() => window.open(plan.link, "_blank")}
                disabled={!!activePlan}
              >
                {activePlan ? "Already Subscribed" : "Choose Plan"}
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Pricing;
